import eventHttp from './eventHttp';

const getPaginatedEvents = (context, page, filter, order, tags, unionTagFilter) => {
  const tagString = tags === null || tags === undefined ? undefined : tags.join(',');

  return new Promise((resolve, reject) => {
    eventHttp.getPaginatedEvents(context, page, filter, order.fieldName, order.order, tagString, unionTagFilter)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getEventsAfterDateTime = (context, tags, date) => {
  const tagString = tags === null || tags === undefined ? undefined : tags.replaceAll(';', ',');

  return new Promise((resolve, reject) => {
    eventHttp.getEventsAfterDateTime(context, tagString, date)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getPaginatedEvents,
  getEventsAfterDateTime
};



// WEBPACK FOOTER //
// ./src/api/event/index.js